import apiRequest from './client';

// GET /api/banks/terminal-report/ (portail company, Rapports > Rapport du Terminal).
// filter = 'All'|'Group'|'Supervisor' (scope, meme convention que Bank Monitoring),
// scope = id du group/superviseur (omis pour 'All'). orderBy = jusqu'a 4
// {field: 'Terminal'|'Nom'|'Banque'|'Superviseur', dir: 'Asc'|'Desc'}, appliques
// dans l'ordre donne (premier = tri principal). Renvoie une liste de
// { terminal, type, nom, code, banque_nom, adresse, superviseur }.
export const fetchTerminalReport = ({ filter = 'All', scope, orderBy = [] } = {}) => {
  const params = new URLSearchParams({ filter });
  if (scope) params.set('scope', scope);
  orderBy.forEach(({ field, dir }, i) => {
    params.set(`order_by${i + 1}`, field);
    params.set(`order_dir${i + 1}`, dir);
  });
  return apiRequest(`/banks/terminal-report/?${params.toString()}`);
};
